import { render, staticRenderFns } from "./initallform.vue?vue&type=template&id=4a4f92b1"
import script from "./initallform.vue?vue&type=script&lang=js"
export * from "./initallform.vue?vue&type=script&lang=js"
import style0 from "./initallform.vue?vue&type=style&index=0&id=4a4f92b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports